import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { requiredValidation } from "../../../utilities/Validation";
import Label from "../../label/label";
import Togglebox from "../../togglebox/togglebox";

const GeneralTab: FC = () => {
    const { translate } = useLocale();
    const { errors } = useFormikContext<any>();

    return <div className="flex flex-col w-full h-full overflow-y-auto ">
        <span className="font-bold text-portal-blue-primary mt-4">{translate.byKey(TranslationKeys.secureComms)}</span>
        <div className="flex flex-row py-2">
            <Label
                htmlFor="tlsMode"
                className="text-sm pt-1">{translate.byKey(TranslationKeys.enable)}:</Label>
            <div className="px-3">
                <Togglebox name="tlsMode" label="" cyName="Enabled" />
            </div>
        </div>
        <div className="py-1">
            <div className="flex flex-col space-y-1">
                <div className="mb-2 w-64">
                    <div className="flex flex-row justify-between" id="tlsUrlIdLabel">
                        <Label htmlFor="tlsUrlId" className="text-xs text-gray-600 mt-1" required>
                            {translate.byKey(TranslationKeys.brokerUrlOrIp)}
                        </Label>
                        {errors.tlsUrlId ? <span className='text-red-600 text-xs'>{errors.tlsUrlId}</span> : null}
                    </div>
                    <div className="flex flex-row justify-between">
                        <Field
                            id="tlsUrlId"
                            type="text"
                            name="tlsUrl"
                            className={`flex flex-row items-center p-1 text-gray-800 text-sm w-64 bg-gray-input`}
                            validate={(value) => requiredValidation(value, translate)} />
                    </div>
                </div>
                <div className="mb-2 w-64">
                    <div className="flex flex-row justify-between" id="tlsPortIdLabel">
                        <Label htmlFor="tlsPortId" className="text-xs text-gray-600 mt-1" required>
                            {translate.byKey(TranslationKeys.brokerPort)}
                        </Label>
                        {errors.tlsPortId ? <span className='text-red-600 text-xs'>{errors.tlsPortId}</span> : null}
                    </div>
                    <div className="flex flex-row justify-between">
                        <Field
                            id="tlsPortId"
                            type="text"
                            name="tlsPort"
                            className={`flex flex-row items-center p-1 text-gray-800 text-sm w-64 bg-gray-input`}
                            validate={(value) => requiredValidation(value, translate)} />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default GeneralTab;